import { doDefaultFetch } from '@nhl/fetch-helpers';
import { constants } from '@nhl/formatter-utilities';

export const fetchStandingsData = args => {
    return doDefaultFetch(
        `/site/api/standings/daily/league/${args.date.format(constants.DATE_FORMAT)}` +
        '?include=team' +
        '&include=teamStats.division' +
        '&include=teamStats.conference' +
        '&include=team.league' +
        '&include=team.logos',
        args
    );
};

export const fetch2020RoundRobinStandingsData = args => {
    const includeJson = [
        'team',
        'team.logos',
        'conference'
    ];

    return doDefaultFetch(
        '/site/api/standings/playoff2020RoundRobin' +
        `?include=${JSON.stringify(includeJson)}`,
        args
    );
}
